import React from 'react'
import { observer } from "mobx-react-lite"
import { Redirect, useMatch, useNavigate } from "@reach/router"
import Profile from './Profile'
import Plan from './Plan'
import Billing from './Billing'
import Layout from '../layout/Layout'
import classes from './Settings.module.scss'
import clsx from 'clsx'
import FadeTransitionRouter from '../../components/FadeTransitionRouter'


const Account = observer(() => {
  const matchBilling = useMatch('/account/billing')
  const matchPlan = useMatch('/account/plan')
  const matchProfile = useMatch('/account/profile')
  const navigate = useNavigate()

  return <Layout>
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.title}>Account</div>
        <div className={classes.tabs}>
          <div className={clsx(classes.tab, matchProfile && classes.active)} onClick={() => navigate('/account/profile')}>Profile</div>
          <div className={clsx(classes.tab, matchPlan && classes.active)} onClick={() => navigate('/account/plan')}>Plan</div>
          <div className={clsx(classes.tab, matchBilling && classes.active)} onClick={() => navigate('/account/billing')}>Billing</div>
        </div>
      </div>
      <FadeTransitionRouter>
        <Billing path="billing" />
        <Plan path="plan" />
        <Profile path="profile" />
        <Redirect from="/account/" to="profile" noThrow />
      </FadeTransitionRouter>
    </div>
  </Layout>
})

export default Account;